import React, {Component} from "react";
import {Form, FormGroup, Input} from "reactstrap";
import FromValidationError from "./FormValidationError";


export default class ForgottenPasswordConfirmation extends Component {

    render() {
        return (
            <Form id="forgottenPasswordConfirmationForm" data-testid="forgottenPasswordConfirmationForm">
                <FormGroup>
                    <Input
                        className={"generic-input gap-top-4"}
                        data-testid="forgottenPasswordConfirmationForm.input.verficationCode"
                        type="text"
                        validations={['required']}
                        name="verificationCode"
                        value={this.props.verificationCode}
                        onChange={this.props.handleChange}
                        id="verificationCode"
                        placeholder="Enter your verification code"
                    />
                    <FromValidationError field={this.props.validationErrors.email}/>
                </FormGroup>
                <FormGroup>
                    <Input
                        className={"generic-input gap-top-4"}
                        data-testid="forgottenPasswordConfirmationForm.input.password"
                        type="password"
                        validations={['required', 'password']}
                        name="password"
                        value={this.props.password}
                        onChange={this.props.handleChange}
                        id="password"
                        placeholder="Enter a password"
                    />
                    <FromValidationError field={this.props.validationErrors.password}/>
                </FormGroup>
                <FormGroup>
                    <Input
                        className={"generic-input gap-top-4"}
                        data-testid="forgottenPasswordConfirmationForm.input.confirmPassword"
                        type="password"
                        validations={['confirmPassword']}
                        name="confirmPassword"
                        value={this.props.confirmPassword}
                        onChange={this.props.handleChange}
                        id="confirmPassword"
                        placeholder="Confirm your password"
                    />
                    <FromValidationError field={this.props.validationErrors.confirmPassword}/>
                </FormGroup>
                <div><p className={'error'} data-testid="forgottenPasswordConfirmationForm.error">{this.props.error}</p></div>
                <div className={"auth-form-buttons gap-top-4"}>
                    <button className={"try-pi-btn auth-form-button-left"} data-testid="forgottenPasswordConfirmationForm.button.back" onClick={this.props.resetState}>BACK</button>
                    <button className={"try-pi-btn auth-form-button-right"} data-testid="forgottenPasswordConfirmationForm.button.resetPassword" onClick={(e) => {
                        this.props.resetPassword(e)
                    }}>RESET PASSWORD
                    </button>
                </div>
            </Form>
        );
    }
}
